/**
 * Псевдонимизация пользователя для внешнего трекера ошибок (Hawk).
 *
 * В Hawk НИКОГДА не уезжает ни email, ни имя, ни аватар — только стабильный
 * необратимый идентификатор. Он нужен ровно для двух вещей:
 *  - «сколько живых людей задело этой ошибкой» (Hawk считает уникальных users);
 *  - сшивка одного инцидента между фронтом и бэком (обе стороны считают хэш
 *    от одного и того же `users.id`, поэтому дают одинаковую строку).
 *
 * Соль зашита константой, а не в env: на фронте она всё равно попадает в
 * бандл, так что «секретности» от env не прибавилось бы, зато появился бы
 * шанс на рассинхрон web ↔ server. Версия в суффиксе — чтобы при
 * необходимости ротировать одной правкой.
 *
 * Обратный путь (хэш → пользователь) намеренно отсутствует.
 */
const HAWK_USER_ID_SALT = "iec-id-hawk-v1";

/** Длина итоговой строки в hex-символах (64 бита — коллизии исключены). */
const HAWK_USER_ID_LENGTH = 16;

/**
 * SHA-256 от `salt:userId`, усечённый до 16 hex-символов.
 *
 * Реализация одна на все среды: `globalThis.crypto.subtle` есть и в браузере
 * (secure context), и в Node 20+. Возвращает `null`, если Web Crypto
 * недоступен: событие уйдёт без привязки к пользователю, но не потеряется.
 */
export async function hashUserIdForHawk(userId: string): Promise<string | null> {
	const subtle = globalThis.crypto?.subtle;
	if (!subtle) return null;

	const data = new TextEncoder().encode(`${HAWK_USER_ID_SALT}:${userId}`);
	const digest = await subtle.digest("SHA-256", data);

	return Array.from(new Uint8Array(digest))
		.map((byte) => byte.toString(16).padStart(2, "0"))
		.join("")
		.slice(0, HAWK_USER_ID_LENGTH);
}
